import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CTA, CustomInput, Modal, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import InputLegend from '../../InputLegend';
import theme from '../../../theme';
import {
  getValues,
  isValidForm,
  newForm,
  newFormField,
} from '../../../../utils/form';
import { RegexpType, validator } from '../../../../utils/validator';
import CustomTextarea from '../../CustomTextarea';
import { CustomBox } from '../../../components/Tutor/style';
import Question from './Question';
import {
  ADD_QUESTION,
  EDIT_QUIZ,
  MODAL_QUIZ_RESET,
  QUIZ_CREATE,
  QUIZ_UPDATE,
} from '../../../../app/redux/actions/tutors';
import {
  CustomBtn,
  DurationWrapper,
  InputContainer,
  PercentageWrapper,
  Value,
} from './style';

const initialForm = newForm([
  newFormField({
    field: 'title',
    required: true,
    type: RegexpType.STRING,
    valid: true,
    value: undefined,
  }),
  newFormField({
    field: 'percentage',
    required: true,
    type: RegexpType.PERCENTAGE_FULL,
    valid: true,
    value: undefined,
  }),
  newFormField({
    field: 'quiz_tentatives',
    required: false,
    type: RegexpType.NUMBER,
    valid: true,
    value: undefined,
  }),
  newFormField({
    field: 'duration',
    required: true,
    type: RegexpType.NUMBER,
    valid: true,
    value: 10,
  }),
  newFormField({
    field: 'description',
    required: true,
    type: RegexpType.STRING,
    valid: true,
    value: undefined,
  }),
]);

export const ModalCreateQuizId = 'ModalCreateQuiz';

const ModalCreateQuiz = ({
  isEvent,
  mediaIsPhone,
  isOpen,
  id,
  payload,
  quiz,
  modalClose,
  addQuestion,
  editQuiz,
  tempQuiz,
  createQuiz,
  updateQuiz,
  modalQuizReset,
}) => {
  const scrollableAreaRef = useRef(null);
  const [form, setForm] = useState({ ...initialForm });
  const [validQuiz, setValidQuiz] = useState(false);

  useEffect(() => {
    if (isEvent) {
      const eventForm = { ...form };
      eventForm.quiz_tentatives.required = true;
      setForm(eventForm);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEvent]);

  useEffect(() => {
    if (isOpen && id === ModalCreateQuizId) {
      if (payload?.tqId) {
        editQuiz(payload?.tqId);
        if (tempQuiz[payload?.tqId]) {
          const currentvalues = tempQuiz[payload.tqId];
          const editForm = { ...initialForm };
          editForm.title.value = currentvalues.title;
          editForm.description.value = currentvalues.description;
          editForm.duration.value = currentvalues.duration * 1;
          editForm.percentage.value = currentvalues.percentage * 1;
          editForm.quiz_tentatives.value = currentvalues.quiz_tentatives * 1;
          setForm({
            ...editForm,
          });
        }
      } else {
        modalQuizReset();
        const editForm = { ...initialForm };
        editForm.title.value = '';
        editForm.description.value = '';
        editForm.duration.value = 10;
        editForm.percentage.value = '';
        editForm.quiz_tentatives.value = '';
        setForm({ ...editForm });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload]);

  const handleOnChange = (field = '', newValue) => {
    const { type } = form[field];
    setForm({
      ...form,
      [field]: {
        ...form[field],
        value: newValue,
        valid:
          typeof newValue === 'object' ? true : validator(type, newValue, true),
      },
    });
  };

  useEffect(() => {
    let isValid = true;
    const questions = Object.values(quiz || {});
    questions.forEach((q) => {
      if (!q?.question) isValid = false;
      let hasCorrectAnswer = false;
      const answers = Object.values(q?.choice_answers || {});
      answers.forEach((a) => {
        if (!a?.answer) isValid = false;
        if (a?.is_correct) hasCorrectAnswer = true;
      });
      if (!hasCorrectAnswer) isValid = false;
    });
    setValidQuiz(isValid);
  }, [quiz]);

  return (
    <Modal
      title="Crea quiz"
      modalId={ModalCreateQuizId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <ScrollableArea
        ref={scrollableAreaRef}
        style={{ maxWidth: `${mediaIsPhone ? 'var(--full-width)' : '80vw'}` }}
      >
        <Text type="b3" mb={32}>
          In questa fase di creazione quiz, è necessario segnalare almeno una
          risposta giusta per ogni domanda, selezionando l'opzione "Risposta
          corretta". Il quiz, una volta conclusa la creazione del percorso
          formativo, non sarà più modificabile.
        </Text>
        <InputContainer>
          <div>
            <InputLegend label="Titolo quiz" required htmlFor="quiz-title" />
            <CustomInput
              size={mediaIsPhone ? 'full' : isEvent ? 's' : 'm'}
              id="quiz-title"
              placeholder="Titolo"
              value={form.title.value}
              onChange={(v) => handleOnChange('title', v)}
            />
          </div>
          <div>
            <InputLegend
              label="Percentuale"
              htmlFor="percentage"
              required
              info="Indicare la percentuale di risposte corrette necessaria per superare il quiz"
            />
            <PercentageWrapper>
              <CustomInput
                size={mediaIsPhone ? 'full' : 's'}
                id="percentage"
                type="number"
                placeholder="0"
                value={form.percentage.value}
                valid={form.percentage.valid}
                error="Il valore deve essere compreso tra 0 e 100"
                errorPosition="absolute"
                onChange={(v) => handleOnChange('percentage', v)}
              />
              <Text type="b4" className="percentage">
                %
              </Text>
            </PercentageWrapper>
          </div>
          {isEvent && (
            <div style={{ position: 'relative' }}>
              <InputLegend
                label="Numero di tentativi"
                required
                htmlFor="tentatives"
              />
              <CustomInput
                size={mediaIsPhone ? 'full' : 's'}
                id="tentatives"
                type="number"
                placeholder="0"
                value={form.quiz_tentatives.value}
                valid={
                  typeof form.quiz_tentatives.value !== 'number' ||
                  (form.quiz_tentatives.valid && form.quiz_tentatives.value > 0)
                }
                errorPosition="absolute"
                onChange={(v) => handleOnChange('quiz_tentatives', Number(v))}
              />
            </div>
          )}
          <div>
            <InputLegend
              label="Durata"
              required
              info="La durata deve essere espressa in minuti"
            />
            <DurationWrapper>
              <CustomBtn
                className={form.duration.value <= 10 ? 'disabled' : ''}
                onClick={() => {
                  if (form.duration.value > 10) {
                    handleOnChange('duration', form.duration.value - 10);
                  }
                }}
              >
                -10
              </CustomBtn>
              <Value>{form.duration.value} min</Value>
              <CustomBtn
                className="last"
                onClick={() =>
                  handleOnChange('duration', form.duration.value + 10)
                }
              >
                +10
              </CustomBtn>
            </DurationWrapper>
          </div>
        </InputContainer>
        <div>
          <InputLegend label="Descrizione" required htmlFor="description" />
          <CustomTextarea
            placeholder="Descrizione"
            id="description"
            value={form.description.value}
            onChange={(value) => handleOnChange('description', value)}
            minHeight={100}
            mb={40}
          />
        </div>
        {Object.keys(quiz).map((k, i) => (
          <Question
            key={`section-${i + 1}`}
            index={i + 1}
            questionKey={k}
            editMode={payload.editMode}
          />
        ))}
        <CustomBox>
          <CTA
            type="tertiary"
            btnText="Aggiungi altra domanda"
            icon="plus"
            onClick={addQuestion}
          />
        </CustomBox>
        <Text type="b3" className="mt-5" mb={24} color={theme().colors.fail}>
          * campo obbligatorio
        </Text>
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="annulla"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
        {payload?.tqId ? (
          <CTA
            type="primary"
            btnText="Aggiorna"
            fullsize={mediaIsPhone}
            onClick={() => {
              const questions = Object.values(quiz)?.map((q) => ({
                question: q?.question,
                choice_answers: Object.values(q?.choice_answers),
              }));
              const body = {
                ...getValues(form),
                choice_elements: questions,
                percentage: Number(form.percentage.value),
              };
              updateQuiz({
                quizId: payload?.tqId,
                body,
                secId: payload?.sectionKey,
                actId: payload?.activityKey,
                field: 'data',
                value: getValues(form),
              });
              modalClose();
            }}
            disabled={!isValidForm(form) || !validQuiz}
          />
        ) : (
          <CTA
            type="primary"
            btnText="Inserisci"
            fullsize={mediaIsPhone}
            onClick={() => {
              const questions = Object.values(quiz)?.map((q) => ({
                question: q?.question,
                choice_answers: Object.values(q?.choice_answers),
              }));
              const body = {
                ...getValues(form),
                choice_elements: questions,
                percentage: Number(form.percentage.value),
              };
              createQuiz({
                body,
                secId: payload?.sectionKey,
                actId: payload?.activityKey,
                field: 'data',
                value: getValues(form),
              });
              modalClose();
            }}
            disabled={!isValidForm(form) || !validQuiz}
          />
        )}
      </Footer>
    </Modal>
  );
};

ModalCreateQuiz.propTypes = {
  isEvent: PropTypes.bool,
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  isOpen: PropTypes.bool,
  id: PropTypes.string,
  payload: PropTypes.object,
  quiz: PropTypes.object,
  tempQuiz: PropTypes.object,

  // dispatch
  modalClose: PropTypes.func.isRequired,
  addQuestion: PropTypes.func.isRequired,
  createQuiz: PropTypes.func.isRequired,
  updateQuiz: PropTypes.func.isRequired,
  editQuiz: PropTypes.func.isRequired,
  modalQuizReset: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { isOpen, id, payload } = state.app.modal;
      const { quiz } = state.tutors.quiz;
      const { data: tempQuiz } = state.tutors.tempQuiz;
      return { isOpen, id, payload, quiz, tempQuiz };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      addQuestion: () => dispatch({ type: ADD_QUESTION }),
      createQuiz: ({ body, secId, actId, field, value }) =>
        dispatch({
          type: QUIZ_CREATE._REQUEST,
          body,
          secId,
          actId,
          field,
          value,
        }),
      updateQuiz: ({ quizId, body, secId, actId, field, value }) =>
        dispatch({
          type: QUIZ_UPDATE._REQUEST,
          quizId,
          body,
          secId,
          actId,
          field,
          value,
        }),
      editQuiz: (id) => dispatch({ type: EDIT_QUIZ, id }),
      modalQuizReset: () => dispatch({ type: MODAL_QUIZ_RESET }),
    })
  ),
  withMediaQueries
)(ModalCreateQuiz);
